import { Outlet } from 'react-router-dom'

import { StarField } from '@/components/visuals'
import { useI18n } from '@/i18n'

import { LanguagePrompt } from './LanguagePrompt'
import { ScrollToTop } from './ScrollToTop'
import { SiteFooter } from './SiteFooter'
import { SiteHeader } from './SiteHeader'

export function RootLayout() {
  const { t } = useI18n()

  return (
    <div className="flex min-h-dvh flex-col">
      <StarField />
      <ScrollToTop />
      <LanguagePrompt />

      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-gold focus:px-5 focus:py-2 focus:text-xs focus:uppercase focus:tracking-widest focus:text-ink"
      >
        {t.common.skipToContent}
      </a>

      <SiteHeader />

      {/* Offset for the fixed header. */}
      <main id="main" className="flex-1 pt-16 lg:pt-20">
        <Outlet />
      </main>

      <SiteFooter />
    </div>
  )
}
